import { CirclePlus } from "lucide-react";
import type { FC } from "react";

import { CustomButton } from "@/components/atoms";
import { cn } from "@/lib/utils";
import { commonIconProps20 } from "@/utils/constants";

interface AddDishProps {
  classes?: string;
  onClick: () => void;
  hasUpdatePermission?: boolean;
}

const AddDish: FC<AddDishProps> = ({
  classes,
  onClick,
  hasUpdatePermission = true,
}) => {
  return (
    <div
      className={cn(
        "rounded-md pr-4 pl-2 py-2 bg-gray-50 border border-gray-200",
        classes
      )}
    >
      <CustomButton
        variant="ghost"
        type="button"
        onClick={onClick}
        data-testid="add-dish-button"
        disabled={hasUpdatePermission}
      >
        <CirclePlus {...commonIconProps20} />
        Add new dish
      </CustomButton>
    </div>
  );
};

export default AddDish;
